import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { CurriculumTreeYearInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class CurriculumTreeYearService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<CurriculumTreeYearInterface[]> {
    return this.personApi
      .getData(userId, 'curriculumTreeYears')
      .pipe(map((res: { curriculumTreeYears: CurriculumTreeYearInterface[] }) => res.curriculumTreeYears));
  }
}
